import useDeletePipeline from '@/api/mutations/pipelines/useDeletePipeline';
import { Button, Modal, ModalProps, useToastContext } from '@payaca/ambrosia';

import { FC } from 'react';
import { useHistory } from 'react-router';

type Props = Pick<ModalProps, 'isOpen' | 'onClose'> & {
  pipelineId: string;
};

const DeletePipelineModal: FC<Props> = ({ isOpen, onClose, pipelineId }) => {
  const history = useHistory();
  const { pushSuccess } = useToastContext();

  const { mutate, isPending } = useDeletePipeline({
    onSuccess: () => {
      pushSuccess('Pipeline deleted');
      history.push('/dashboard');
    },
  });

  return (
    <Modal title="Delete pipeline" isOpen={isOpen} onClose={onClose}>
      <Modal.Body>
        Are you sure you want to delete this pipeline? This action cannot be
        undone.
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button variant="secondary" onClick={() => onClose?.()}>
            Cancel
          </Button>
          <Button
            colour="negative"
            disabled={isPending}
            isProcessing={isPending}
            onClick={() => mutate({ pipelineId })}
          >
            Delete
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePipelineModal;
